<div class="sheet-status" [ngClass]="{'card-body': standaloneMode}">
    <app-status-details
        [showReason]="showReason"
        [standaloneMode]="standaloneMode"
        [status]="newStatus"
        [date]="statusChangedDate"
        [whoChanged]="whoChanged"
        [reason]="reason"
        >
    </app-status-details>
    <div class="sheet-status-container__history-link" *ngIf="standaloneMode">
        <button class="btn btn-xs" (click)="showHistoryModal()">
            {{ l('ShowStatusHistory') }}
        </button>
    </div>
</div>

<app-history-status-modal
    #historyStatusModal
    [allocationSheetId]="allocationSheetId">
</app-history-status-modal>
